import React from 'react'
import styles from './Cancel.module.css'

function Cancel() {
  return <div className={styles.Wrapper}>Purchase Canceled</div>
}

export default Cancel
